const dtOptions = {
  tableClass: 'table',
  selectable: {
    selectAllCheckboxTemplate: (id) => `<div class='custom-control custom-checkbox'><input type='checkbox' id='${id}' class='custom-control-input' /><label class='custom-control-label' for='${id}'></label></div>`,
    checkboxTemplate: (id, cssClass, data, checked) => `<div class='custom-control custom-checkbox'><input type='checkbox' id='${id}' class='custom-control-input ${cssClass}' data-id='${data}' ${checked} /><label class='custom-control-label' for='${id}'></label></div>`
  },
  autoWidth: false,
  order: [0, 'asc'],
  serverSide: true,
  stateSave: true,
  pagingType: 'simple_numbers',
  dom: "<'table-responsive'rt><'table-controls'lp<'control-spacer'>>",
  pageLength: 10,
  lengthMenu: [10, 25, 50, 75],
  language: {
    paginate: {
      previous: '<svg viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.16608 1.62109L1.00903 5.77808l4.15705 4.1571" stroke="currentColor" class="stroke" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      next: '<svg viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M.833984 9.93518l4.157046-4.1571L.833984 1.62109" stroke="currentColor" class="stroke" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    }
  },
};

const classes = {
  sWrapper: "dataTables_wrapper",
  sFilterInput: "form-control",
  sLengthSelect: "form-control",
  sProcessing: "dataTables_processing card"
};

export default {
  dtOptions,
  classes
}